import { MaterializedProductCollectionBlock } from '@fagmobler/sanity';
import { ALGOLIA_INDEX_NAME } from '@/lib/algolia/searchClient';
import { FagmoblerAlgoliaProduct } from '@fagmobler/types';
import { cleanStegaString } from '@/lib/sanity/cleanStegaString';

export const populateBlockWithProducts = async (
  block: MaterializedProductCollectionBlock
) => {
  const { searchClient } = await import('@/lib/algolia/searchClient');
  const index = searchClient.initIndex(ALGOLIA_INDEX_NAME);

  if (typeof window !== 'undefined') {
    console.warn('Getting products on client side');
  }

  if (!block.productSKUs || block.productSKUs.length === 0) {
    console.log('No products found');
    return [];
  }

  return index
    .getObjects<FagmoblerAlgoliaProduct>(
      block.productSKUs.filter(Boolean).map((sku) => cleanStegaString(sku))
    )
    .then((data) => data.results.filter(Boolean) as FagmoblerAlgoliaProduct[]);
};
